import {CanActivateFn, GuardResult, MaybeAsync} from '@angular/router';
import {inject} from '@angular/core';
import {ProfileService} from '@epg-apps/profile-api';
import {map} from 'rxjs';

/**
 * @description
 * This guard is a temporary solution for the fact you can't have a resolver run before a guard.
 * Related information: https://github.com/angular/angular/issues/42953
 *
 * @example
 * ```typescript
 * const routes: Routes = [
 *   {
 *     path: 'admin',
 *     component: AdminComponent,
 *     canActivate: [userProfileResolveGuard] *
 *   },
 * ];
 * ```
 *
 * @returns True if the user is successfully retrieved and set, false if not
 */

export const userProfileResolveGuard: CanActivateFn =
  (): MaybeAsync<GuardResult> => {
    return inject(ProfileService)
      .loadUserProfileAsObservable()
      .pipe(map((userProfile) => userProfile !== undefined));
  };
